export enum AlertLevel {
  Information,
  Warning,
  Alert,
}

export enum SkuDimensionType {
  Attribute = 0,
  Unit = 10,
  Brand = 20,
}

export enum LineLevelCouponDiscDisplay {
  None = 0,
  Percent = 10,
  Dollars = 20,
}

export enum PurchaseProcess {
  Standard = 0,
  Web2Print = 10,
  CheckoutCharge = 20,
  NavInk = 30,
  Kit = 40,
  BottleDeposit = 50,
  AssemblyCharge = 60,
  DeliveryCharge = 70,
}

export enum SupercedeDisplayCondition {
  Never = 0,
  ForDifferentUnits = 10,
  ForMatchingUnits = 20,
  Always = 30,
}

export const enum SkuQueryParams {
  GroupId = "SKUGroupID",
  CategoryId = "SKUCategoryID",
}

export enum SupercedeSubType {
  NotTaken = 0,
  Soft = 10,
  Hard = 20,
}

export enum QueryParamKeys {
  Keyword = "Keyword",
  Category = "Category",
  SortCode = "sc",
  SearchKeyword = "sk",
  Page = "page",
  CouponOfferId = "coid",
  FirstItem = "fi",
  FirstResult = "fr",
  ExcludeDefaultPricePlan = "EDPP",
  OrderAgain = "oa",
  OrderId = "orderId",
  Finder = "Finder",
  ListId = "ListId",
  Manufacturer = "Manufacturer",
  Device = "Device",
  RecentlyViewedItems = "rvi",
  PricePlan = "PricePlan",
  CatDesc1 = "CatDesc1",
  PPCCode = "PPCCode",
  ItemIndex = "ii",
  AlgoliaQueryId = "aqid"
}

export enum PathParamKeys {
  ShoppingApp = "shop",
  ProductDetails = "pd"
}

export enum WbmPage {
  Search,
  SkuGroups,
  ListDetails,
  ProductDetails,
}

export enum TargetCouponOfferCode {
  AddToCartSlideIn = "RZ2"
}
